import { Moon, Sparkles, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme, type Theme } from './theme-provider';

const ORDER: readonly Theme[] = ['glass', 'light', 'dark'];

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();

  function next() {
    const idx = ORDER.indexOf(theme);
    const target = ORDER[(idx + 1) % ORDER.length] as Theme;
    setTheme(target);
  }

  const Icon = theme === 'light' ? Sun : theme === 'dark' ? Moon : Sparkles;

  return (
    <button
      type="button"
      aria-label="Alternar tema"
      title={`Tema: ${theme}`}
      onClick={next}
      className={cn(
        'inline-flex h-9 w-9 items-center justify-center rounded-md transition',
        'text-[var(--fg)] hover:bg-[color-mix(in_oklch,var(--fg)_8%,transparent)]',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--accent)]',
        className,
      )}
    >
      <Icon className="h-4 w-4" />
    </button>
  );
}
